import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { AdminRoutingModule } from "./admin-routing.module";
import { SharedModule } from "../shared/shared.module";
import { AssessmentChartsModule } from "../assessment-charts/assessment-charts.module";
import { ThemeModule } from "../theme/theme.module";

import { AdminComponent } from './admin/admin.component';
import { ClientListComponent } from './client-list/client-list.component';
import { ClientNewComponent } from './client-new/client-new.component';
import { ClientEditComponent } from './client-edit/client-edit.component';
import { AssessmentListComponent } from './assessment-list/assessment-list.component';
import { AssessmentNewComponent } from './assessment-new/assessment-new.component';
import { AssessmentEditComponent } from './assessment-edit/assessment-edit.component';
import { AssessmentAdminComponent } from './assessment-admin/assessment-admin.component';
import { QuestionSetEditComponent } from './question-set-edit/question-set-edit.component';
import { QuestionSetCoreFormComponent } from './question-set-core-form/question-set-core-form.component';
import { QuestionSetNewComponent } from './question-set-new/question-set-new.component';
import { ScaleNewComponent } from './scale-new/scale-new.component';
import { ScaleEditComponent } from './scale-edit/scale-edit.component';

import { QuestionNewComponent } from './question-new/question-new.component';
import { QuestionEditComponent } from './question-edit/question-edit.component';

import { AssessmentGroupEditComponent } from './assessment-group-edit/assessment-group-edit.component';
import { LabelNewComponent } from './label-new/label-new.component';
import { LabelEditComponent } from './label-edit/label-edit.component';
import { ScaleRangeNewComponent } from './scale-range-new/scale-range-new.component';
import { ScaleRangeEditComponent } from './scale-range-edit/scale-range-edit.component';
import { AdminShopComponent } from './admin-shop/admin-shop.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { ShopItemsComponent } from './shop-items/shop-items.component';
import { CheckoutThankyouComponent } from './checkout-thankyou/checkout-thankyou.component';
import { ViewOrderComponent } from './view-order/view-order.component';
import { CartWidgetComponent } from './cart-widget/cart-widget.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { OrderHistoryComponent } from './order-history/order-history.component';
import { ViewOrderPageComponent } from './view-order-page/view-order-page.component';
import { CheckoutStatusMonitorComponent } from './checkout-status-monitor/checkout-status-monitor.component';
import {ReportsModule} from "../reports/reports.module";
import { LoginModule } from 'app/login/login.module';
import { AssessmentViewComponent } from './assessment-view/assessment-view.component';
import { ScalesListViewComponent } from './scales-list-view/scales-list-view.component';
import { QuestionSetListViewComponent } from './question-set-list-view/question-set-list-view.component';
import { AssessmentDetailsViewComponent } from './assessment-details-view/assessment-details-view.component';
import { AssessmentTokensListComponent } from './assessment-tokens-list/assessment-tokens-list.component';
import { QuestionLabelsEditComponent } from './question-labels-edit/question-labels-edit.component';
import {ClientSearchService} from "./services/client-search.service";
import { AssessmentAssignerService } from './services/assessment-assigner.service';
import { ClientSendInvitationComponent } from '../client-send-invitation/client-send-invitation.component';
import { AnnouncementBarComponent } from './announcement-bar/announcement-bar.component';
import { AnnouncementService } from './services/announcement.service';
import { ClientManageAssignmentsComponent } from './client-manage-assignments/client-manage-assignments.component';
import { UserUpgradeSubscriptionNoticeComponent } from './user-upgrade-subscription-notice/user-upgrade-subscription-notice.component';
import { SubscriptionDialogComponent } from './subscription-dialog/subscription-dialog.component';
import { SubscriptionService } from './services/subscription.service';
import { ModalModule } from 'ngx-modal';
import { BillingPlansComponent } from './billing-plans/billing-plans.component';
import { LibraryAssetsModule } from 'app/library-assets/library-assets.module';
import { MessageTemplateService } from './services/message-template.service';

@NgModule({
  imports: [
    RouterModule
    ,SharedModule
    ,LibraryAssetsModule
    ,AssessmentChartsModule
    ,ReportsModule
    ,ThemeModule
    ,LoginModule
    ,FormsModule
    ,ModalModule
    ,AdminRoutingModule
  ],
  declarations: [
    AdminComponent,
    ClientListComponent,
    ClientNewComponent,
    ClientEditComponent,
    AssessmentListComponent,
    AssessmentNewComponent,
    AssessmentEditComponent,
    AssessmentAdminComponent,
    QuestionSetEditComponent,
    QuestionSetCoreFormComponent,
    QuestionSetNewComponent,
    QuestionNewComponent,
    QuestionEditComponent,
    ScaleNewComponent,
    ScaleEditComponent,
    AssessmentGroupEditComponent,
    LabelNewComponent,
    LabelEditComponent,
    ScaleRangeNewComponent,
    ScaleRangeEditComponent,
    AdminShopComponent,
    CheckoutComponent,
    ShopItemsComponent,
    CheckoutThankyouComponent,
    ViewOrderComponent,
    CartWidgetComponent,
    MyAccountComponent,
    OrderHistoryComponent,
    ViewOrderPageComponent,
    CheckoutStatusMonitorComponent,
    AssessmentViewComponent,
    ScalesListViewComponent,
    QuestionSetListViewComponent,
    AssessmentDetailsViewComponent,
    AssessmentTokensListComponent,
    QuestionLabelsEditComponent,
    ClientSendInvitationComponent,
    AnnouncementBarComponent,
    ClientManageAssignmentsComponent,
    UserUpgradeSubscriptionNoticeComponent,
    SubscriptionDialogComponent,
    BillingPlansComponent
  ]
  ,providers: [ClientSearchService, AssessmentAssignerService, AnnouncementService, SubscriptionService, MessageTemplateService]
})
export class AdminModule { }



// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts